
import { ApproachLeftSection, BackgroundTextArea, ObjectiveCardSection } from "./ProposalEndClientDetailPageLeftSection"

export const PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS = {
  BACKGROUND: "background",
  OBJECTIVE: "objective",
  APPROACH: "approach",
  TIMELINES_AND_INVESTMENT: "timelinesAndInvestment"
}

export const PROPOSAL_END_CLIENT_DETAIL_PAGE_LABELS = {
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH]: "Approach",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND]: "Background",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE]: "Objective",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.TIMELINES_AND_INVESTMENT]: "Timelines and Investment"
}

export const sectionHeadersForDetailPage = {
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND]: "where is skechers today?",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE]: "what is the priority?",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH]: "how can jasper colin help?",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.TIMELINES_AND_INVESTMENT]: "metrics",
}

export const PROPOSAL_END_CLIENT_DETAIL_PAGE_LEFT_COMPONENTS = {
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH]: ApproachLeftSection,
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND]: BackgroundTextArea,
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE]: ObjectiveCardSection,
}

export const marketingMaterialName = {
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.APPROACH]: "resourceMaterials",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.BACKGROUND]: "supportingDocs",
  [PROPOSAL_END_CLIENT_DETAIL_PAGE_KEYS.OBJECTIVE]: "caseStudies",
}

